import { createFileRoute, redirect } from '@tanstack/react-router'
import { KepribadianAI } from '../../../../components/KepribadianAI'

export const Route = createFileRoute('/desa/$slug/dashboard/kepribadian-ai')({
  beforeLoad: ({ context, params }) => {
    const { user } = context as any
    if (user?.role !== 'platform_admin') {
      throw redirect({ to: '/desa/$slug/dashboard', params: { slug: params.slug } })
    }
  },
  component: () => {
    const { desaId } = Route.useRouteContext() as any
    if (!desaId) return null
    return <KepribadianAI desaId={desaId} />
  },
})
